import { render, staticRenderFns } from "./MandatoryTraining.vue?vue&type=template&id=6a00bdb8&scoped=true&"
import script from "./MandatoryTraining.vue?vue&type=script&lang=js&"
export * from "./MandatoryTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a00bdb8",
  null
  
)

export default component.exports